import { Tooltip } from "@mui/material";

export default function AdjustStyledTableCell({ content, size }) {
    return <>{content?.length >= size ? <Tooltip title={content}>{content.substr(0, size) + "..."}</Tooltip> : content}</>;
}
